<template>
    <v-card class="pa-0">
        <v-toolbar color="primary">
            <v-btn icon @click="fechar"><v-icon color="white">close</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title style="color: white;">Visualizar comprovante</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout column class="pa-0 ma-0">
            <v-flex align-self-center class="pa-0 ma-0">
                <v-img contain v-if="imagemAnexada" :src="imagemAnexada" alt="imagem do comprovante" width="600" class="pa-0 ma-0"/>
                <object v-if="arquivoAnexado" width="600" height="600" type="application/pdf" :data="arquivoAnexado"></object>
                <v-card v-if="!imagemAnexada && !arquivoAnexado" color="grey" width="400" height="400">
                    <v-layout justify-center align-center fill-height>
                        <div class="title white--text pa-4 text-xs-center">Sem comprovante anexado</div>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
export default {
  props: ['fatura'],
  data () {
      return {
          imagemAnexada: null,
          arquivoAnexado: null
      }
  },
  methods: {
    fechar () {
      this.$emit('fechar')
      this.limparCampos()
    },
    limparCampos () {
      this.arquivoAnexado = null
      this.imagemAnexada = null
    }
  },
  mounted () {
      if (this.fatura && this.fatura.comprovante_pagamento) {
          if (this.fatura.comprovante_pagamento.indexOf('png') === -1) {
        this.arquivoAnexado = this.fatura.comprovante_pagamento
      } else {
        this.imagemAnexada = this.fatura.comprovante_pagamento
      }
    }
  }
}
</script>
